// Shown while a lazily-loaded route chunk downloads. Deliberately minimal and
// centred — on a slow connection this is the first thing a student sees, so it
// should read as "loading", never as a broken page.
export default function RouteFallback() {
  return (
    <div style={{
      minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexDirection: 'column', gap: 14,
    }}>
      <div style={{
        width: 30, height: 30, borderRadius: '50%',
        border: '3px solid var(--nat-d)', borderTopColor: 'var(--org)',
        animation: 'tt-spin 0.7s linear infinite',
      }} />
      <style>{'@keyframes tt-spin{to{transform:rotate(360deg)}}'}</style>
    </div>
  );
}
